export default __webpack_public_path__ + "static/media/diamond-cut-2@2x.eaef1375.png";